import React from "react";
import { Toaster } from "react-hot-toast";
import Routes from "./Routes";

function App() {
  return (
    <>
      <Routes />
      <Toaster position="top-right" />
    </>
  );
}

export default App;
